import {
  createReleaseNote as create,
  deleteReleaseNote as deleteItem,
  getReleaseNote as get,
  listReleaseNotes as list,
  updateReleaseNote as update
} from '@cbgms/api/modules/releasenotes/requests'
import { IPaginatedRequest } from '@cbgms/api/request'
import { GetReleaseNoteResponse, IReleaseNote } from '@cbgms/api/modules/releasenotes'

import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { IResponse } from '@cbgms/api'

export const listReleaseNotes = (params: IPaginatedRequest) => ({
  type: [types.GET_RELEASE_NOTES, types.GET_RELEASE_NOTES_SUCCESS, types.GET_RELEASE_NOTES_FAILED],
  payload: {
    api: 'support',
    request: list(params)
  }
})

export const getReleaseNote = (UUID: string) =>
  AsyncAction<GetReleaseNoteResponse>({
    type: [types.GET_RELEASE_NOTE, types.GET_RELEASE_NOTE_SUCCESS, types.GET_RELEASE_NOTE_FAILED],
    payload: {
      api: 'support',
      request: get(UUID)
    }
  })

export const createReleaseNote = (data: Partial<IReleaseNote>) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.CREATE_RELEASE_NOTE, types.CREATE_RELEASE_NOTE_SUCCESS, types.CREATE_RELEASE_NOTE_FAILED],
    payload: {
      api: 'support',
      request: create(data)
    }
  })

export const updateReleaseNote = (UUID: string, data: Partial<IReleaseNote>) => ({
  type: [types.UPDATE_RELEASE_NOTE, types.UPDATE_RELEASE_NOTE_SUCCESS, types.UPDATE_RELEASE_NOTE_FAILED],
  payload: {
    api: 'support',
    request: update(UUID, data)
  }
})

export const deleteReleaseNote = (UUID: string, dryRun: boolean) => ({
  type: [types.DELETE_RELEASE_NOTE, types.DELETE_RELEASE_NOTE_SUCCESS, types.DELETE_RELEASE_NOTE_FAILED],
  payload: {
    api: 'support',
    request: deleteItem(UUID, dryRun)
  }
})
